export default {
  getAppointmentInfoByCondition: '/appointment/api/{0}/{1}/appointmentsSn',
  getAppointmentSignInInfoByCondition: '/appointment/api/all-appointments',
  createAppointment: '/appointment/api/v2/sn_reserve',
  cancelAppointment: '/appointment/api/{0}/{1}/{2}/cancel/{3}',
  robotizationDeductionAppointment: '/appointment/api/{0}/{1}/{2}/{3}/pay-reserve/3',
  manualDeductionAppointment: '/appointment/api/pay-mini-reserve',
  deleteAppointmentRecord: '/appointment/api/appointment/delete/{0}',
  getQueueInfo: '/appointment/api/queues',
  signIn: '/appointment/api/v2/sign-in',
  createCandidate: '/appointment/api/sn_candidate/appointments',
  getCandidateRecord: '/appointment/api/candidate/candidateAppointmentsList',
  cancelCandidateRecord: '/appointment/api/candidate/cancelCandidate',
  creditAppointment: '/appointment//api/appointId/pay-reserve-credit',
  modifyTechnologyAppointment: '/appointment/api/medical_appoint/appointments',
  pcRegisterScanQR: '/appointment/api/pay-qrcode-reserve' // [PC]预约扫码付
};
